import { createApi } from '@reduxjs/toolkit/query/react';
import { baseQueryWithReauth } from './utils';

const GET_RETRIEVAL = '/retrieval';
const CHARGEBACK = `${ GET_RETRIEVAL }/chargeback`;

export const customerApi = createApi({
    reducerPath: 'customerApi',
    baseQuery: baseQueryWithReauth,
    endpoints: builder => ({
        getRetrival: builder.query({
            query: ({ order_id }) => ({
                url: GET_RETRIEVAL,
                params: { order_id }
            }),
            forceRefetch: () => true,
        }),
        createChargeback: builder.mutation({
            query: (body) => ({
                url: CHARGEBACK,
                method: 'POST',
                body
            }),
        }),
        getCustomerCardInfo: builder.query({
            query: ({ id }) => ({
                url: `customers/${ id }/card_info`,
            }),
            forceRefetch: () => true,
        }),
        deleteCustomer: builder.mutation({
            query: ({ params: { id, ...payload} }) => ({
                url: `customers/${ id }/delete`,
                method: 'POST',
                body: payload
            }),
        })
    })
});

export const {
    useLazyGetRetrivalQuery,
    useCreateChargebackMutation,
    useLazyGetCustomerCardInfoQuery,
    useDeleteCustomerMutation,
} = customerApi;
